import Backbone from "backbone";
import * as preact from "preact";
import * as _ from "underscore";

import * as languageMap from "shared/languageMap";

import compositeViewMixin from "compositeViewMixin";
import BooksCollection from "models/BooksCollection";
import LibraryFiltersView from "views/LibraryFiltersView";
import PaginatedLibraryListView from "views/PaginatedLibraryListView";

const PublicLibraryView = Backbone.View.extend({
  initialize: function (options) {
    _.extend(this, compositeViewMixin);

    this.options = options;
    this.models = options.models;
    this.books = new BooksCollection();
    this.searchQuery = new Backbone.Model({
      query: "",
    });

    this.silentlyUpdatingSearch = false;
    this.silentlyUpdatingFilters = false;

    // TODO: should search box be separate view?
    this.listenTo(this.searchQuery, "change", () => {
      // reset filters
      if (!this.silentlyUpdatingSearch) {
        this.silentlyUpdatingFilters = true;
        this.models.user.set("publicBooksCategories", ["All"]);
        this.models.user.set("publicBooksFilter", {
          metrics_CEF: "A1-C2",
          metrics_words: "0-Infinity",
        });
        this.silentlyUpdatingFilters = false;
      }
      this.$(".searchInput").val(this.searchQuery.get("query"));
    });

    this.listenTo(
      this.models.user,
      "change:publicBooksCategories change:publicBooksFilter",
      () => {
        if (!this.silentlyUpdatingFilters) {
          this.silentlyUpdatingSearch = true;
          this.searchQuery.set("query", "");
          this.silentlyUpdatingSearch = false;
        }
      }
    );

    this.render();
  },
  render: function () {
    this.setSubviews({
      paginatedLibraryList: new PaginatedLibraryListView({
        collection: this.books,
        models: this.models,
        searchQuery: this.searchQuery,
        appRouter: this.options.appRouter,
        query: {
          public: true,
        },
        rendered: this.options.renderedCallback,
      }),
    });

    this.libraryFiltersViewElement = document.createElement("div");
    preact.render(
      preact.h(LibraryFiltersView, {
        user: this.models.user,
        searchQuery: this.searchQuery,
      }),
      this.libraryFiltersViewElement
    );

    this.$el
      .empty()
      .append(this.libraryFiltersViewElement)
      .append(this.subviews.paginatedLibraryList.$el);

    this.listenTo(this.subviews.paginatedLibraryList, "noBooks", () => {
      const languageString =
        languageMap.map[this.models.user.get("currentLearningLanguage")]
          .english;
      this.$el.html(
        '<p style="text-align:left;position:relative;height:150px;padding:10px">' +
          '<img src="/content/upArrow.png" style="margin-bottom:20px"></img>' +
          '<span style="margin-left:15px;max-width:400px;position:absolute;bottom:0">No texts have been shared in ' +
          languageString +
          " yet. Upload your own texts to read privately or become the first contributor to the " +
          languageString +
          " public texts section.</span></p>"
      );
    });

    this.delegateEvents(this.events);
  },
  remove: function (...args: any[]) {
    // Remove the preact view, triggering its componentWillUnmount() function
    preact.render(null, this.libraryFiltersViewElement);
    // @ts-expect-error Backbone typings expect no arguments, but this is safe in our usage
    Backbone.View.prototype.remove.apply(this, args);
  },
});

export default PublicLibraryView;
